<template>
    <a-modal :title="$t('publicLang.DownloadCenter')+' - '+this.asnNo" :footer="null" v-model="visible" :width=windowWidth :maskClosable="false">
        <div class="content" :style="'width:'+listWidth+'px'">
            <div class="listFile">
                <div class="topButton">
                    <a-button @click="deleteFile()" size="big" type="primary" style="background-color: red;border: none;">{{ $t('generic.Delete') }}</a-button>
                    <a-button @click="downloadZip()" size="big" type="primary" style="margin-left: 20px;">{{ $t('generic.Zip') }}</a-button>
                </div>
                <!--列表-->
                <a-row style="margin: 9px;width: 400px;">
                    <vxe-table
                            stripe
                            highlight-hover-row
                            border
                            resizable
                            show-overflow
                            size="mini"
                            ref="downloadCenterRef"
                            :data.sync="tableData">
                        <template v-slot:empty>
                    <span style="color: red;">
                      <p>{{ $t('pubGicSet.NoRecordfound') }}</p>
                    </span>
                        </template>
                        <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                        <vxe-table-column field="uid" title="UID" show-header-overflow="ellipsis" show-overflow="ellipsis" :visible="false"></vxe-table-column>
                        <vxe-table-column field="fileName" title="File Name" show-header-overflow="ellipsis" show-overflow="ellipsis" ></vxe-table-column>
                        <vxe-table-column field="action" title="Action" show-header-overflow="ellipsis" show-overflow="ellipsis" >
                            <template slot-scope="scope">
                                <img class="active" :title="$t('generic.Delete')" src="../../../assets/img/Liqutor-delete.png" @click="deleteFile(scope.row.uid)">
                                <img class="active" style="margin-left: 10px;" :title="$t('publicLang.Download')" src="../../../assets/img/download.png" @click="downloadFile(scope.row)">
                                <img v-if="scope.row.type == 'PIC'" class="active" style="margin-left: 10px;" :title="$t('publicLang.Preview')" src="../../../assets/img/preview.png" @click="preview(scope.row.url)">
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </a-row>
            </div>
            <div v-show="isShow" style="float: left;">
                <img :src="imgUrl" width="380" height="380" style="margin: 0 10px 10px 10px;border-radius: 5px;"/>
            </div>
        </div>
    </a-modal>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import axios from "axios";
    import store from "../../../store";
    import cookie from "../../../api/cookie";
    // import Template from "../reportCom/template";

    export default{
        // components: {Template},
        data(){
            return{
                windowWidth: 0,//弹出窗口的宽度
                listWidth: 0,
                labelSpan: '24',
                visible: false,
                fileName: '',//文件名称
                errMsg:[],
                fontColor:'red',
                paramsData: {},
                isUploading: false,
                defaultImg: "",
                asnUid:"",
                asnNo:'',//ASN号码
                IfStatusBtn:false,
                repeatflag: 0,
                status: 'ready',
                files: [],
                uploading: false,
                percent: 0,
                uploadType:'',//上传类型
                tableData: [],
                isShow:false,
                imgUrl:'',
            }
        },
        methods:{
            show(param){
                this.imgUrl = ''
                this.isShow = false
                this.windowWidth = 420
                this.listWidth = 420
                this.visible = true
                this.paramsData = param
                this.fromData = {}
                this.files= []
                this.errMsg = []
                let params = {}
                this.asnUid = param.uidList;
                params.asnUid = param.uidList;
                this.uploadType =  param.uploadType;
                if(params.asnUid!=null){
                    this.asnNo= params.asnUid;
                }
                this.init();
            },
            init(){//根据OrderNo查询所有的文件
                let params = {
                    recNo: this.asnNo,
                    uploadType: this.uploadType
                }
                ajax.get(api.GETFILENAME,params).then(res=>{
                    if (res.code === 200) {
                        this.tableData = res.data
                    }
                })
            },
            deleteFile(uid){//删除文件
                let uidList = [];
                if(uid != null){//单个操作
                    uidList.push(uid);
                }else{//批量操作
                    let Records = this.$refs.downloadCenterRef.getCheckboxRecords()
                    if(Records.length == 0){
                        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                        return;
                    }
                    for(let i in Records){
                        uidList.push(Records[i].uid)
                    }
                }
                let params = new FormData();
                params.append("uidList", uidList);
                ajax.post(api.DELETEFILE, params).then(res=>{
                    if(res.code == 200){
                        this.init()
                        this.$message.success(res.msg)
                        this.imgUrl = "";
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            downloadFile(row){//下载文件(单个文件)
                let params = {
                    uid: row.uid
                }
                axios.defaults.timeout =  1000*60*60;//设置请求超时时间:1h
                store.commit("updataLoading", { pbLoading: true });
                axios.get(ajax.ajaxUrl()+api.DOWNLOADFILE, {
                    params,
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                })
                    .then(data=>{
                        store.commit("updataLoading", { pbLoading: false });
                        if (!data) {
                            return;
                        }
                        var blob = new Blob([data.data], {
                            type:"application/octet-stream;charset=UTF-8"
                        });
                        var url = window.URL.createObjectURL(blob);
                        var aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        aLink.setAttribute("download", row.fileName);
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink); //下载完成移除元素
                        window.URL.revokeObjectURL(url); //释放掉blob对象
                    })
                    .catch(function(error) {
                        store.commit("updataLoading", { pbLoading: false });
                        alert(error);
                    });
            },
            downloadZip(){//下载文件(压缩Zip)
                let uidList = [];
                let Records = this.$refs.downloadCenterRef.getCheckboxRecords()
                if(Records.length == 0){
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                    return;
                }
                for(let i in Records){
                    uidList.push(Records[i].uid)
                }
                let params = {
                    uidList: uidList.join(",")
                }
                let aData = new Date();
                let dateTime = aData.getFullYear() + "" + (aData.getMonth() + 1) + "" + aData.getDate() + "" + aData.getHours() + "" + aData.getMinutes() + "" + aData.getUTCSeconds();
                axios.defaults.timeout =  1000*60*60;//设置请求超时时间:1h
                store.commit("updataLoading", { pbLoading: true });
                axios.get(ajax.ajaxUrl()+api.DOWNLOADZIP, {
                    params,
                    headers: {
                        Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                })
                    .then(data=>{
                        store.commit("updataLoading", { pbLoading: false });
                        if (!data) {
                            return;
                        }
                        var blob = new Blob([data.data], {
                            type:"application/octet-stream;charset=UTF-8"
                        });
                        var url = window.URL.createObjectURL(blob);
                        var aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        aLink.setAttribute("download",  this.asnNo +"_"+ dateTime + ".zip");
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink); //下载完成移除元素
                        window.URL.revokeObjectURL(url); //释放掉blob对象
                    })
                    .catch(function(error) {
                        store.commit("updataLoading", { pbLoading: false });
                        alert(error);
                    });
            },
            preview(url){//预览图片
                this.windowWidth = 820;
                this.listWidth = 820;
                this.imgUrl = url;
                this.isShow = true;//显示图片
            }
        }
    }
</script>
<style>
    .content{
        background-color: white;
        float: left;
        margin-left: -10px;
        border-radius: 5px;
    }
    .topButton{
        border: none;
        padding-top: 10px;
        text-align: center;
    }
    .listFile {
        border: 1px solid #e5e5e5;
        float: left;
        border-radius: 5px;
    }
    .active{
        cursor: pointer;
        width: 22px;
        height: 22px;
    }
</style>